<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.999876877163649,0.004996877163648605C3.5826368771636488,0.004996877163648605,0.004874807163648605,3.5827568771636487,0.004874807163648605,7.999996877163649C0.004874807163648605,12.417196877163649,3.5826368771636488,15.994996877163649,7.999876877163649,15.994996877163649C12.41709687716365,15.994996877163649,15.994896877163649,12.417196877163649,15.994896877163649,7.999996877163649C15.994896877163649,3.5827568771636487,12.41709687716365,0.004996877163648605,7.999876877163649,0.004996877163648605ZM7.000966877163648,9.998766877163648L8.999716877163648,9.998766877163648L8.999716877163648,3.0031368771636484L7.000966877163648,3.0031368771636484L7.000966877163648,9.998766877163648ZM8.999716877163648,12.996896877163648L7.000966877163648,12.996896877163648L7.000966877163648,10.998096877163649L8.999716877163648,10.998096877163649L8.999716877163648,12.996896877163648Z"
          fill-rule="evenodd"
          fill="#D14343"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Danger',
} as DefineComponent
</script>
